import { ChangeDetectorRef, Component, OnInit, Renderer2 } from "@angular/core";
import { MatDialog, MatDialogRef } from "@angular/material/dialog";
import { AdminPreOrderEditComponent } from "../admin-pre-order-edit/admin-pre-order-edit.component";
import { AdminService } from "../admin.service";
import { CommonServices } from "src/app/common.services";

@Component({
  selector: "app-admin-pre-orders",
  templateUrl: "./admin-pre-orders.component.html",
  styleUrls: ["./admin-pre-orders.component.css"],
})
export class AdminPreOrdersComponent implements OnInit {
  tripType: any = "-1";
  pre_order_view: boolean = false;
  pre_order_list: boolean = true;
  matDialogref: MatDialogRef<AdminPreOrderEditComponent>;
  timeRemaining: number = 30 * 60; // 30 minutes in seconds
  timer: any;
  formattedTime: string = "30:00";
  token: any;
  preorderData: any = [];
  perpage: any = 10;
  page: any = 1;
  fetch_page: any = 0;
  fetch_page1: any = 0;
  currentPage: any = 0;
  startPage: any = 1;
  last_page: any = 1;
  document_array: any = [];
  document_array1: any = [];
  paginationTrips: boolean = true;
  loading: boolean = false;
  fromLocation: any = -1;
  toLocation: any = -1;
  userType: any = -1;
  download: any = -1;
  woid: any = -1;
  perPage: any = 10;
  selectedData: any = [];
  woData: any;
  socketTimer: any;
  intervalId: any;
  totalLoadingPoints: any = 0;
  totalUnloadingPoints: any = 0;
  selected_id: any;
  selected_data: any;
  dataLoaded: boolean = false; // Initially, text selection is disabled
  socketLoading: boolean = false;
  selectedDataLength: number = 0;
  tripBookedCount: number = 0;
  allottedQty: number = 0;
  isEditing: boolean = false;
  bidRankingData: any[] = [];

  constructor(
    private matDialog: MatDialog,
    private service: AdminService,
    private commonService: CommonServices,
    private renderer: Renderer2,
    private cdr: ChangeDetectorRef
  ) {
    this.renderer.listen("document", "dblclick", (event) => {
      event.preventDefault();
    });
  }

  ngOnInit(): void {
    this.token = localStorage.getItem("adminToken");
    // Check if the page is visited for the first time
    if (!sessionStorage.getItem("preOrderFirstLoad")) {
      sessionStorage.setItem("preOrderFirstLoad", "true"); // Mark as visited
      window.location.reload(); // Reload the page once
    } else {
      // Retrieve last saved pages
      const savedPage = sessionStorage.getItem("lastPreorderFetchPage");
      this.fetch_page = savedPage ? parseInt(savedPage) : 1;

      this.startPage = this.fetch_page;
      this.currentPage = this.fetch_page;
      this.preOrderList();

      const savedPage1 = sessionStorage.getItem("lastPreorderViewFetchPage");
      this.fetch_page1 = savedPage1 ? parseInt(savedPage1) : 1;

      this.startPage = this.fetch_page1;
      this.currentPage = this.fetch_page1;
    }

    this.startTimer();
    let triptype = "pre_orders";
    localStorage.setItem("tripType", triptype);
  }

  ngOnDestroy() {
    if (this.timer) {
      clearInterval(this.timer);
    }
  }

  startTimer() {
    this.timer = setInterval(() => {
      this.timeRemaining--;
      this.formattedTime = this.formatTime(this.timeRemaining);

      if (this.timeRemaining <= 0) {
        clearInterval(this.timer);
        this.formattedTime = "00:00"; // Stop at 00:00
      }
    }, 1000);
  }

  // Format time as MM:SS
  formatTime(seconds: number): string {
    const minutes = Math.floor(seconds / 60);
    const secs = seconds % 60;
    return `${String(minutes).padStart(2, "0")}:${String(secs).padStart(
      2,
      "0"
    )}`;
  }

  getWeightValue(truckWeight: string): number {
    // Extract the numeric value from the truck weight string
    return Number(truckWeight.split(" ")[0]);
  }

  getTotalPrice(item: any): number {
    const price = Number(item.price) || 0;

    if (item.workorderInfo[0]?.pay_as_load_quantity === "unloaded_quantity") {
      const unloadingPoint =
        Number(item.tripInfo[0]?.workOrderOtherDetails?.unloading_point) || 0;
      return price * unloadingPoint;
    } else {
      const loadingPoint =
        Number(item.tripInfo[0]?.workOrderOtherDetails?.loading_point) || 0;
      return price * loadingPoint;
    }
  }

  // Return s9_margin if it's defined and is > 0, otherwise use workorder_margin
  getEffectiveMargin(woData: any): number {
    return (woData?.s9_margin && woData.s9_margin > 0)
      ? woData.s9_margin
      : woData.workorder_margin;
  }

  // Calculate S9 CutOff Price using the effective margin
  calculateS9CutOffPrice(woData: any): number {
    const margin = this.getEffectiveMargin(woData);
    return woData.price_per_ton - (woData.price_per_ton * margin / 100);
  }


  preOrderList() {
    this.loading = true;
    this.preorderData = []; // Clear previous data if any
    // location.reload();
    this.service
      .preorderadminList(this.token, this.perpage, this.startPage)
      .subscribe(
        (res: any) => {
          this.preorderData = res.body.data.data;
          this.document_array.push(res.body.data.meta);
          this.last_page = res.body.data.meta.lastPage;
          this.loading = false;

          setTimeout(() => {
            let filterData = this.preorderData.filter(
              (data: any) => this.selected_id == data._id
            );
            this.commonService.publishMessage(
              "workorder-time-update",
              filterData[0]
            );
          }, 500);
          // Ensure the data is set correctly and prevent duplication
          const updatedItem = this.preorderData.find(
            (data: any) =>
              data.workorder_id === this.selected_data?.workorder_id
          );
          this.viewWo(updatedItem);
        },
        (error) => {
          this.loading = false;
          this.paginationTrips = false;
        }
      );
  }
  
  getStopNames(stops: any[]) {
    if (!stops || stops.length === 0) return 'No';
    return stops.map(s => s.city_name).join(', ');
  }

  editWo(item: any) {
    this.selected_data = item;
    this.selected_id = item._id;
    this.matDialogref = this.matDialog.open(AdminPreOrderEditComponent, {
      width: "40vw",
      height: "50vh",
      autoFocus: false,
      disableClose: true,
      data: item,
    });

    this.matDialogref.afterClosed().subscribe((data) => {
      if (data.success === "close") {
        this.loading = true; // Show loading spinner
        this.paginationTrips = false;
        this.preorderData = [];
        this.preOrderList();
        // Fetch the latest data for selected work order
        this.fetchPublishedEvent(this.selected_data);
        this.loading = false;
      }
    });
  }

  getBidRankingForWO(workorderId: string) {
    this.service.getPreOrderBidRanking(this.token, workorderId).subscribe(
      (res: any) => {
        this.bidRankingData = res.body?.data || [];
      },
      (err) => {
        console.error("Failed to fetch bid ranking", err);
      }
    );
  }

  getRemainingTime(expiryTime: number, rankingTimer: number): string {
    if (!expiryTime || isNaN(expiryTime) || !rankingTimer || isNaN(rankingTimer)) {
      return '-';
    }
    const now = Date.now();
    const remaining = expiryTime - now;
    if (remaining <= 0) return 'Expired';
    const thresholdMs = rankingTimer * 60 * 1000;
    if (remaining > thresholdMs) {
      return 'Wait';
    }
    const minutes = Math.floor(remaining / 1000 / 60);
    const seconds = Math.floor((remaining / 1000) % 60);
    const paddedMinutes = String(minutes).padStart(2, '0');
    const paddedSeconds = String(seconds).padStart(2, '0');
    return `${paddedMinutes}:${paddedSeconds} left`;
  }

  viewWo(item?: any) {
    if (!item) return;
    this.getBidRankingForWO(item._id);
    this.fetchPublishedEvent(item);

    // Fetch initial data when view is clicked
    this.woData = item;
    this.pre_order_list = false;
    this.pre_order_view = true;
    this.socketLoading = true; // Show loader while data is being fetched
    this.socketTimer = "";
    // Convert woData to an array
    // Convert woData to an array if it's an object
    const woDataArray = Array.isArray(this.woData)
      ? this.woData
      : [this.woData];

    this.totalLoadingPoints = 0; // Reset total loading points
    this.totalUnloadingPoints = 0; // Reset total unloading points

    woDataArray.forEach((trip: any) => {
      if (trip.tripInfo && trip.tripInfo.length > 0) {
        trip.tripInfo.forEach((tripDetails: any) => {
          const workOrderDetails = tripDetails.workOrderOtherDetails;
          if (workOrderDetails) {
            const loadingPoint = workOrderDetails.loading_point || 0;
            const unloadingPoint = workOrderDetails.unloading_point || 0;
            this.totalLoadingPoints += loadingPoint;
            this.totalUnloadingPoints += unloadingPoint;
          }
        });
      }
    });

    // Clear any existing interval
    if (this.intervalId) {
      clearInterval(this.intervalId);
    }
    this.startPage = 1;

    // Simulate data update and fetch fresh data
    this.service
      .getPreOrdersReports1(
        this.token,
        item._id,
        this.fromLocation,
        this.toLocation,
        this.userType,
        this.download,
        this.woid,
        this.perPage,
        this.startPage
      )
      .subscribe(
        (res: any) => {
          this.socketLoading = false;
          this.selectedData = res.body.data;

          this.document_array1.push(res.body.meta);
          this.last_page = res.body.meta.lastPage;

          // Get the updated expiry time from the item or response
          const currentTime = Date.now();
          const timeDifference = item.workorder_expiry_time - currentTime;

          // Ensure valid time difference
          if (timeDifference > 0) {
            // Start the countdown with the updated time
            this.startCountdown(timeDifference);
          } else {
            this.socketTimer = { remainingTime: "Expired" }; // Set expired if time is invalid
          }
        },
        (error) => {
          this.socketLoading = false; // Hide loader on error
        }
      );
  }

  // **Separate method to fetch published events (socket trigger)**
  fetchPublishedEvent(item: any) {
    this.socketLoading = true; // Start loader immediately
    this.cdr.detectChanges(); // Force UI update for loader

    this.commonService.getPublishedEvent(item._id).subscribe(
      (result: any) => {
        const updatedData = result?.body?.updatedPreorderDetails ?? [];

        // Set the selectedData length
        this.selectedDataLength = updatedData.length;

        // Get the last allottedQty value
        const lastRecord = updatedData[updatedData.length - 1];
        const lastAllottedQty =
          (lastRecord?.workorderInfo?.[0]?.total_tons || 0) -
          (lastRecord?.workorderInfo?.[0]?.remaining_tons || 0);

        // const lastAllottedQty =
        //   lastRecord?.workorderInfo?.[0]?.total_tons -
        //     lastRecord?.workorderInfo?.[0]?.remaining_tons ?? 0;

        // Log the last allottedQty if it exists
        if (lastAllottedQty !== this.allottedQty) {
          this.allottedQty = lastAllottedQty;
        }

        // Calculate how many trips are booked
        this.tripBookedCount = updatedData.filter(
          (trip: any) => trip.trip_status === "trip_booked"
        ).length;

        // Delay status check to simulate processing
        setTimeout(() => {
          // Check if any trip_status changed to "trip_booked"
          const isTripBooked = updatedData.some(
            (trip: any) => trip.trip_status === "trip_booked"
          );

          if (isTripBooked) {
            // Keep loader while processing status change
            this.socketLoading = true;
            this.cdr.detectChanges();

            // Simulate processing and update data after 2 seconds
            setTimeout(() => {
              this.selectedData = updatedData; // Update after status check
              this.socketLoading = false; // Stop loader after data update
              this.cdr.detectChanges();
            }, 2000);
          }
          setTimeout(() => {
            if (updatedData.length > 0) {
              // Ensure updatedData is not empty before updating
              this.selectedData = updatedData;
            } else {
            }
            this.socketLoading = false;
            this.cdr.detectChanges();
          }, 1000);
        }, 500); // Initial delay for status check

        // Reset arrays
        this.document_array1 = [];
        this.last_page = 1;
      },
      (error) => {
        this.socketLoading = false; // Ensure loader stops on error
        this.cdr.detectChanges();
      }
    );
  }

  pagination(page_status: any) {
    let newPage = this.fetch_page;

    if (page_status == "-1") {
      newPage = Math.max(1, this.fetch_page - 1); // Prevent negative pages
    } else if (page_status == "1") {
      newPage = this.fetch_page + 1;
    } else if (page_status == "first") {
      newPage = 1; // Set the first page correctly
    } else if (page_status == "last") {
      newPage = this.last_page || 1; // Ensure last page is fetched correctly
    }

    this.fetch_page = newPage;
    this.currentPage = newPage;
    this.startPage = newPage;

    // Save current page to localStorage
    sessionStorage.setItem("lastPreorderFetchPage", newPage.toString());

    this.preOrderList();
  }

  startCountdown(timeDifference: number) {
    if (this.intervalId) {
      clearInterval(this.intervalId); // Clear existing interval
    }

    if (!timeDifference || isNaN(timeDifference) || timeDifference <= 0) {
      this.socketTimer = { remainingTime: "Expired" };
      return;
    }

    // Store the expected end time
    const endTime = Date.now() + timeDifference;

    this.intervalId = setInterval(() => {
      const currentTime = Date.now();
      const remainingTime = endTime - currentTime;

      if (remainingTime <= 0) {
        clearInterval(this.intervalId);
        this.socketTimer = { remainingTime: "Expired" };
        // this.preOrderList();
        this.viewWo(this.woData);

        return;
      }

      const totalMinutes = Math.floor(remainingTime / (1000 * 60));
      const seconds = Math.floor((remainingTime / 1000) % 60);
      const formattedMinutes = String(totalMinutes).padStart(2, "0");
      const formattedSeconds = String(seconds).padStart(2, "0");

      this.socketTimer = {
        remainingTime: `${formattedMinutes}:${formattedSeconds}`,
      };
    }, 1000);
  }
}
